import { render, staticRenderFns } from "./UILotteryField.vue?vue&type=template&id=0ae5c886&"
import script from "./UILotteryField.vue?vue&type=script&lang=ts&"
export * from "./UILotteryField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports